import React, { useEffect, useState } from 'react';
import { _T } from "../../../../../base-react/src/Localization";
import { apis, hooks, models } from '@vote4dance/judging-sdk';
import { Badge, Typography } from 'antd';
import { NavLink } from 'react-router-dom';
var StreamHandler = apis.streaming.StreamHandler;
var Stream = hooks.streams.Stream;
var CheckinResultSource = models.checkins.CheckinResultSource;
const { Text } = Typography;
export const CheckinNavMenuItem = (props) => {
    let { event, competitions, defaultCompetitionId } = props;
    const [results, loadingResults] = Stream(event ? CheckinResultSource(event.competition_id) : undefined);
    const [totalCheckins, setTotalCheckins] = useState();
    const [totalCancelCount, setTotalCancelCount] = useState(0);
    useEffect(() => {
        let unsubscribeList = [];
        if (competitions) {
            competitions.forEach(competition => {
                const unsubscribe = StreamHandler.get().subscribe(CheckinResultSource(competition.competition_id).url, (data) => {
                    onReports(competition.competition_id, data);
                });
                unsubscribeList.push(unsubscribe);
            });
        }
        return () => unsubscribeList.forEach(unsubscribe => unsubscribe());
    }, [competitions]);
    useEffect(() => {
        if (event) {
            onReports(event.competition_id, results ? results : []);
        }
    }, [results]);
    const onReports = (competition_id, list) => {
        if (list && list.length > 0) {
            var newObject = totalCheckins ? totalCheckins : {};
            newObject[competition_id] = list.filter((a) => a.checkin_at && a.checkin_status > 0);
            setTotalCheckins(newObject);
        }
        calculateTotalCancelCount();
    };
    const calculateTotalCancelCount = () => {
        const myCheckins = { ...totalCheckins };
        const keys = Object.keys(myCheckins);
        if (keys.length > 0) {
            const total = keys.reduce((sum, key) => {
                return sum + myCheckins[key].length;
            }, 0);
            setTotalCancelCount(total);
        }
    };
    if (totalCancelCount > 0) {
        return (React.createElement(NavLink, { to: `comp/${defaultCompetitionId}/checkin` },
            React.createElement(Badge, { count: totalCancelCount, offset: [25, 10] },
                React.createElement(Text, { strong: true }, _T('checkin.title')))));
    }
    return (React.createElement(NavLink, { to: `comp/${defaultCompetitionId}/checkin` }, _T('checkin.title')));
};
